// import { createMemoryHistory, createRouter } from 'vue-router'
import { createWebHistory, createRouter } from 'vue-router'

import SiprComponent from './components/SiprComponent.vue'
import HomeView from './components/HomeView.vue'
import TheoryView from './components/TheoryView.vue'
import AboutView from './components/AboutView.vue'
// import axios from 'axios';

const baseURL = process.env.BASE_URL;

// const backendURL = 'https://sipr.freeddns.org'
// const backendURL = 'http://chestnut.jesuitas.vpn:8000'
// axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
// axios.defaults.xsrfCookieName = "csrftoken";
// axios.defaults.withXSRFToken = true;
// axios.defaults.withCredentials = true;
// axios.get(backendURL)
//   .then(response => console.log('Success!' + response))
//   .catch(err => console.error(err));

const routes = [
  { path: baseURL + 'theory', component: TheoryView },
  { path: baseURL + 'about', component: AboutView },
  { path: baseURL + 'passage/:passage', component: SiprComponent},
  { path: baseURL, component: HomeView },
]

const router = createRouter({
  // history: createMemoryHistory(),
  history: createWebHistory(),
  routes,
})

export default router
